import React from 'react';
import PropTypes from 'prop-types';

import {
  Toolbar,
  ToolbarRight,
  ToolbarToggle,
  ToolbarTooltip,
  TooltipIcon,
  TooltipText,
  ToolbarLeft,
  ToolbarIconWrapper,
  ChatUIToolTip,
  ChatUIToolTipFixedWidth,
} from './ChatUIToolbar.styles';
import { ChatUIIconButton } from '../ChatUIIconButton/ChatUIIconButton';
import { chatUITabs } from 'constants/chatUI';

const propTypes = {
  chatUIOpen: PropTypes.bool.isRequired,
  toggleOpenState: PropTypes.func.isRequired,
  selectTab: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
};

export default function ChatUIToolbar({ chatUIOpen, toggleOpenState, selectTab, activeTab }) {
  const whyAmISeeingText = {
    [chatUITabs.macros.tabName]: 'The macro you need for this customer is likely one of these.',
    [chatUITabs.productRecs
      .tabName]: `Based on the customer's previous orders or this conversation, we have some products they may be interested in.`,
  };

  /** *** RENDER FUNCS *****/

  const renderToolbarRight = () => {
    return chatUIOpen ? (
      <ToolbarRight>
        <ToolbarTooltip>
          <TooltipText>Why am I seeing this?</TooltipText>
          <ChatUIToolTipFixedWidth arrow placement="top" content={whyAmISeeingText[activeTab]}>
            <TooltipIcon alt={'tooltip'} src={'/images/chatUI/question-mark-tooltip.svg'} />
          </ChatUIToolTipFixedWidth>
        </ToolbarTooltip>
        <ToolbarToggle
          alt={'toolbar open toggle'}
          src={'/images/chatUI/close-toolbar.svg'}
          onClick={() => toggleOpenState()}
        />
      </ToolbarRight>
    ) : (
      <ToolbarRight>
        <ToolbarToggle
          alt={'toolbar open toggle'}
          src={'/images/chatUI/open-toolbar.svg'}
          onClick={() => toggleOpenState()}
        />
      </ToolbarRight>
    );
  };

  const renderToolbarIcons = () => {
    let toolbarTabs = [];
    for (let key in chatUITabs) {
      let tab = chatUITabs[key];

      toolbarTabs.push(
        <ChatUIToolTip key={tab.tabName} arrow placement="top" content={`${tab.tabName}`}>
          <ToolbarIconWrapper>
            <ChatUIIconButton
              alt={`${tab.tabName}`}
              src={activeTab === tab.tabName ? `${tab.activeSrc}` : `${tab.inactiveSrc}`}
              onClick={() => selectTab(tab.tabName)}
              isActive={activeTab === tab.tabName}
            />
          </ToolbarIconWrapper>
        </ChatUIToolTip>
      );
    }

    return toolbarTabs;
  };

  return (
    <Toolbar>
      <ToolbarLeft>{renderToolbarIcons()}</ToolbarLeft>
      {renderToolbarRight()}
    </Toolbar>
  );
}

ChatUIToolbar.propTypes = propTypes;
